module.exports = "/assets/img/logo.png";